import { ThreadStateEnum } from '@anecdotes/commenting';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Observable, switchMap, combineLatest, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuditorsFilter, CommentFilterOption, MentionedThreadsFilter } from '../../models';
import { CommentPanelManagerService } from '../../services';

@Component({
  selector: 'app-no-comments-empty-state',
  templateUrl: './no-comments-empty-state.component.html',
})
export class NoCommentsEmptyStateComponent implements OnInit {
  @HostBinding('class')
  private classes = 'flex flex-col gap-3 items-center font-main text-navy-70 text-center px-11 py-8 h-full';

  emptyStateTranslationObj$: Observable<{ key: string; icon: string }>;

  constructor(private commentPanelManagerService: CommentPanelManagerService) { }

  ngOnInit(): void {
    this.emptyStateTranslationObj$ = this.commentPanelManagerService.getSelectedFilterOption().pipe(
      filter(Boolean),
      switchMap(({ value }) => {
        return combineLatest([of(value), this.commentPanelManagerService.getResourceType()]);
      }),
      map(([value, resourceType]: [CommentFilterOption, string]) => {
        switch (value) {
          case ThreadStateEnum.Active:
            return { key: `activeEmptyState${resourceType}`, icon: 'commenting/add-comment' };
          case MentionedThreadsFilter:
            return { key: 'mentionedEmptyState', icon: 'commenting/checkmark' };
          case AuditorsFilter:
            return { key: 'auditorsEmptyState', icon: 'commenting/checkmark' };
          case ThreadStateEnum.Resolved:
            return { key: 'resolvedEmptyState', icon: 'commenting/checkmark' };
        }
      })
    );
  }

  buildTranslationKey(emptyStateTranslation: string, relativeKey: string): string {
    return `commenting.noCommentsEmptyState.${emptyStateTranslation}.${relativeKey}`;
  }
}
